import { PayloadAction, createSlice } from "@reduxjs/toolkit";
export interface AppSlice {
  collapsed: boolean;
  studySetupToggler: boolean;
}

const initialState: AppSlice = {
  collapsed: false,
  studySetupToggler: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    toggleSidebarCollapse: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload;
    },
    toggleStudySetup: (state) => {
      state.studySetupToggler = !state.studySetupToggler;
    },
  },
});

export const { toggleSidebarCollapse, toggleStudySetup } = appSlice.actions;

export default appSlice.reducer;
